var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Upload',{ref:"upload",staticClass:"quill-upload display-none",attrs:{"show-upload-list":false,"format":[
            'jpg',
            'jpeg',
            'png',
            'gif',
            'mp4',
            'avi',
            'mov',
            'pdf',
            'xls',
            'xlsx',
            'doc',
            'docx',
        ],"max-size":51200,"on-exceeded-size":_vm.exceededSize,"on-format-error":_vm.handleFormatError,"on-success":_vm.handleUploadSuccess,"headers":_vm.headers,"action":_vm.uploadImg}},[_c('i',{staticClass:"el-icon-upload"})]),_c('quill-editor',{ref:"myQuillEditor",staticClass:"myQuillEditor",attrs:{"disabled":_vm.disabled,"options":_vm.editorOption},on:{"change":_vm.onEditorChange},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }